<div
    class="popover-wrapper"
    [ngClass]="{
        'popover-completed-step': step.State === stepStateEnum.Completed,
    }"
>
    <div class="popover-title bold-text" data-uiid="new-eff-popover-step-name">
        {{ step.NameKey | transloco }}
    </div>
    <div class="popover-content">
        @if (step.State !== stepStateEnum.Completed) {
            <div class="table-row" data-uiid="new-eff-popover-assignees">
                <div class="table-cell bold-text">{{ 'controls.effWorkflowPopover.assignees' | transloco }}</div>
                <div class="table-cell">
                    <div class="d-flex flex-column assigned-persons-wrapper">
                        @for (user of step.AssignedUsers; track user) {
                            <div>
                                {{ user }}
                            </div>
                        }
                    </div>
                </div>
            </div>
        }
        @if (step.State === stepStateEnum.Completed) {
            <div class="table-row" data-uiid="new-eff-popover-completed-by">
                <div class="table-cell bold-text">{{ 'controls.effWorkflowPopover.completedBy' | transloco }}</div>
                <div class="table-cell">{{ step.CompletedBy }}</div>
            </div>

            <div class="table-row" data-uiid="new-eff-popover-date-completed">
                <div class="table-cell bold-text">{{ 'controls.effWorkflowPopover.dateCompleted' | transloco }}</div>
                <div class="table-cell">{{ step.CompletedOn }}</div>
            </div>
        }
        <div class="table-row" data-uiid="new-eff-popover-due-date">
            <div class="table-cell bold-text">{{ 'controls.effWorkflowPopover.dueDate' | transloco }}</div>
            <div class="table-cell">{{ step.DueDate }}</div>
        </div>
    </div>
</div>
